import { render } from "./GovernanceView.vue?vue&type=template&id=417bebaa&scoped=true"
import script from "./GovernanceView.vue?vue&type=script&lang=js"
export * from "./GovernanceView.vue?vue&type=script&lang=js"

import "./GovernanceView.vue?vue&type=style&index=0&id=417bebaa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-417bebaa"]])

export default __exports__